import { PhotoPackage } from './../types';
import PlayerModel from '@/components/player/model';
import { ref, onMounted, watch, ComputedRef, Ref } from '@vue/composition-api';
import { useApolloModel } from 'vue-apollo-model';

export function useVideoLog(log: (logInfo: unknown) => void, photoPackage: ComputedRef<PhotoPackage>, beginTime: Ref<number>) {
    const playerModel = useApolloModel(PlayerModel);
    const navigationStartTime = ref(0);
    const pageLoadTime = ref(0);
    const waitingTime = ref(0);
    onMounted(() => {
        navigationStartTime.value = performance && performance.timing.navigationStart;
        const stopEffect = watch(() => playerModel.kernelInitTime, time => {
            if (time) {
                // 取 navigationStart 到kernel加载前的时间作为pageLoadTime
                pageLoadTime.value = time - navigationStartTime.value;
                stopEffect();
            }
        });
    });
    const sendVideoLog = (duration: number) => {
        // 取 kernelLoadedTime 减去当前时间为 waitingTime
        waitingTime.value = playerModel.kernelLoadedTime - beginTime.value;
        const summaryQosData = playerModel.summaryQosData;
        log({
            type: 'VIDEO_PLAY',
            event_name: 'VIDEO_PLAY',
            event_value: {
                play_duration: summaryQosData?.actual_play_duration,
                auto_play_judge: 'TRUE',
                waiting_kernel_time: waitingTime.value,
                page_load_time: pageLoadTime.value,
            },
            event_content: {
                ...photoPackage.value,
            },
            otherLog: {
                photo_duration: duration,
            },
        });
    };

    return {
        sendVideoLog,
        beginTime,
    };
}
